import {
  AfterViewInit,
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild
} from '@angular/core';
import {PlaningDate} from '../../../../api/src/template/template.model';
import {NgbTooltip} from '@ng-bootstrap/ng-bootstrap';
import {first} from 'rxjs/operators';
import {TranslateService} from '@ngx-translate/core';

@Component({
    selector: 'app-days-list-edit',
    templateUrl: './days-list-edit.component.html',
    styleUrls: ['./days-list-edit.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class DaysListEditComponent implements AfterViewInit {

  @Input() days: { [key: string]: boolean };
  @Input() idx: number;
  @Input() readonly  = false;
  public newDays: { [key: string]: boolean } = {};
  @Output() daysChange = new EventEmitter();
  @ViewChild('daysTooltipHandler', {static: false}) daysTooltip: NgbTooltip;

  constructor(private ngxTranslateService: TranslateService) {
  }

  ngAfterViewInit() {
    if (this.daysTooltip) {
      this.daysTooltip.hidden.pipe(first()).subscribe(data => {
        this.daysChange.emit(this.days);
      });
    }
  }

  daysAsString(days: { [key: string]: boolean }): string[] {
    const weekdays: { [key: string]: string } = {
      monday: 'mon',
      tuesday: 'tue',
      wednesday: 'wed',
      thursday: 'thu',
      friday: 'fri',
      saturday: 'sat',
      sunday: 'sun'
    };

    return Object.entries(days).filter(v => v[1]).map(v => {
      if (typeof v[0] === 'string') {
        return this.ngxTranslateService.instant(weekdays[v[0]] || v[0]);
      }
      return '';
    });
  }
}

